import React from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const DetachedFloorPlanFilter = ({
  filter,
  activeFilterParams,
  updateParams
}) => {
  const { has_floor_plans, ...restOfParams } = activeFilterParams
  const isActive = has_floor_plans

  const toggleFloorPlanListing = () => {
    const newParams = { ...restOfParams }

    if (!isActive) {
      newParams['has_floor_plans'] = 'true'
    }
    updateParams(newParams)
  }

  return (
    <CTA
      type='block-tertiary'
      tag='button'
      className={`[ f-p-a-010 f-m-a-005 f-d-iflr ] SearchResultsFilters-button SearchResultsFilters-button__with-icon ${
        isActive ? 'is-active' : ''
      }`}
      onClick={toggleFloorPlanListing}
      wtData={{
        'CTA-click': {
          label: isActive ? filter.tracking.off : filter.tracking.on,
          location: 'filter-panel'
        }
      }}>
      <Icon
        icon='floor-plan-rectangle-14px'
        className='[ f-icon-020 f-c-st-inherit f-icon-t-mini f-m-r-010 ]'
      />
      <span className='[ f-d-bl f-p-h-005 f-t-ellip ]'>{filter.label}</span>
    </CTA>
  )
}

export default DetachedFloorPlanFilter
